<tt-page *ngIf="!!page">
    <div class="col-xs-12 sp-0 height-full" *ngIf="'mobile' | mediaQuery">
        <tt-card>
            <ng-container *ngTemplateOutlet="info"></ng-container>
        </tt-card>

        <tt-grid *ngIf="!!grid" class="flex-1" [(ttOptions)]="grid"></tt-grid>
    </div>

    <div class="height-full" *ngIf="['tablet', 'laptop', 'desktop'] | mediaQuery">
        <tt-divider ttRememberId="acreportlayoutmenu_dividers">
            <tt-divider-columns>
                <tt-divider-pane ttSize="20">
                    <tt-card>
                        <ng-container *ngTemplateOutlet="info"></ng-container>
                    </tt-card>
                </tt-divider-pane>

                <tt-divider-pane ttSize="80">
                    <tt-grid *ngIf="!!grid" class="flex-1" [(ttOptions)]="grid"></tt-grid>
                </tt-divider-pane>
            </tt-divider-columns>
        </tt-divider>
    </div>
</tt-page>

<ng-template #info>
    <ng-container *ngIf="!!page">
        <tt-input ttLabel="acreportlayout_keyno" [ttModel]="page.acreportlayout_keyno" ttReadonly></tt-input>
        <tt-input ttLabel="acreportlayout_name" [ttModel]="page.acreportlayout_name" ttReadonly></tt-input>
        <tt-checkbox ttLabel="res" [(ttModel)]="page.res"></tt-checkbox>
        <tt-button-goto ttText="acreportlayoutmenu_edit" ttGoto="acreportlayout" [ttGotoParms]="{ acreportlayout_keyno: page.acreportlayout_keyno }" ttTextAlign="left"></tt-button-goto>
        <tt-button ttText="acreportlayoutmenu_renum" (ttClick)="renumber()" [ttLoading]="renumbering" ttTextAlign="center" ttType="primary" ttIcon="fas fa-sync-alt"></tt-button>
        <tt-button ttText="acreportlayoutmenu_copy" (ttClick)="copy()" [ttLoading]="copying" ttTextAlign="center" ttType="primary" ttIcon="fas fa-sync-alt"></tt-button>
        <tt-button ttText="acreportlayoutmenu_delete" (ttClick)="delete()" [ttLoading]="deleting" ttIcon="fas fa-trash-alt" ttType="danger" ttTextAlign="center"></tt-button>
    </ng-container>
</ng-template>
